/* eslint-disable */
<template>
    <v-layout row wrap >
        <v-flex lg6 sm12 xs12>
            <v-widget title="" content-bg="white">
                <div slot="widget-content">

                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">L’importance de préservation de la biodiversité biologique  </div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=q57
                                    color="success"
                            >
                                {{q57}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">Des connaissances sur les zones rouges d’interdiction de pêche  </div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=q58
                                    color=cyan darken-2
                            >
                                {{q58}}%

                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">. Avez-vous une idée sur la période légale de pêche des palourdes </div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=q60
                                    color=deep-orange
                            >
                                {{q60}}%

                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2"> Respectez-vous cette durée </div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=q61
                                    color=purple lighten-2
                            >
                                {{q61}}%
                            </v-progress-circular>
                        </div>
                    </div>
                </div>
            </v-widget>
        </v-flex>
        <v-flex lg6 sm12 xs12>
            <v-widget title="Avez-vous une idée sur les lieux légaux de pêche des palourdes ?  " content-bg="white">
                <div slot="widget-content" id="q62" style="height:400px; " ref="q62">
                </div>
            </v-widget>
        </v-flex>
        <v-flex lg3 sm12 xs12> </v-flex>
        <v-flex lg6 sm12 xs12>
            <v-widget title="" content-bg="white">
                <div slot="widget-content">


                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">Avez-vous une idée sur les lieux légaux de pêche des palourdes ?  </div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=q63
                                    color=cyan darken-2
                            >
                                {{q63}}%

                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">Est ce qu’il y a une diminution de productivité des palourdes ?   </div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=q66
                                    color=deep-orange
                            >
                                {{q66}}%

                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">Est ce qu’il y a une diminution de productivité des palourdes ?  </div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=q67
                                    color=purple lighten-2
                            >
                                {{q67}}%
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">Avez-vous des connaissances sur les causes de la haute de température ?  </div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=q68
                                    color="success"
                            >
                                {{q68}}%
                            </v-progress-circular>
                        </div>
                    </div>
                </div>
            </v-widget>
        </v-flex>
        <v-flex lg3 sm12 xs12> </v-flex>

    </v-layout>
</template>

<script>
    import EChart from '@/components/chart/echart';
    import MiniStatistic from '@/components/widgets/statistic/MiniStatistic';
    import PostListCard from '@/components/widgets/card/PostListCard';
    import ProfileCard from '@/components/widgets/card/ProfileCard';
    import PostSingleCard from '@/components/widgets/card/PostSingleCard';
    import WeatherCard from '@/components/widgets/card/WeatherCard';
    import PlainTable from '@/components/widgets/list/PlainTable';
    import PlainTableOrder from '@/components/widgets/list/PlainTableOrder';
    import VWidget from '@/components/VWidget';
    import Material from 'vuetify/es5/util/colors';
    import VCircle from '@/components/circle/VCircle';
    import BoxChart from '@/components/widgets/chart/BoxChart';
    import ChatWindow from '@/components/chat/ChatWindow';
    import CircleStatistic from '@/components/widgets/statistic/CircleStatistic';
    import LinearStatistic from '@/components/widgets/statistic/LinearStatistic';
    var echarts = require('../../node_modules/echarts');

    /* eslint-disable */
    export default {
        name: "q1-compenent",
        components: {
            VWidget,
            MiniStatistic,
            ChatWindow,
            VCircle,
            WeatherCard,
            PostSingleCard,
            PostListCard,
            ProfileCard,
            EChart,
            BoxChart,
            CircleStatistic,
            LinearStatistic,
            PlainTable,
            PlainTableOrder
        },
        data() {
            return {
                color: Material,

                q57:'0',
                q58:'0',
                q60:'0',
                q61:'0',
                q62:'0',
                q63:'0',
                q67:'0',
                q68:'0',
            }
        },
        computed: {
            activity() {
                return API.getActivity();
            },
            posts() {
                return API.getPost(3);
            },
            siteTrafficData() {
                return API.getMonthVisit;
            },
        },
        created(){



        },
        mounted(){
            this.  fetchData()

        },
        methods: {

            fetchData() {
                var labelOption1 = {

                    normal: {
                        fontSize: 16,
                        fontWeight:"bold"
                    }
                };
                const ECharts = window.echarts || undefined;
                if (ECharts === undefined) {
                    console.error('ECharts is not defined');
                }
                var myChart37 = ECharts.init(this.$refs.q62, 'material');
                myChart37.showLoading();

                var formData = new FormData();
                if((this.$route.params.state)==='Toutes les villes'){
                    formData.append('pays','');
                }
                if((this.$route.params.state)==='Sfax'){
                    formData.append('pays','صفاقس');
                }
                if((this.$route.params.state)==='Gabès'){
                    formData.append('pays','قابس');
                }
                if((this.$route.params.state)==='Médenine'){
                    formData.append('pays','مدنين');
                }
                this.$http.post('https://acg-generations.com/acg_laravel/public/question57',formData,
                        {
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                                'Access-Control-Allow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
                                'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }
                        }).then(response => {
                    var data = response.bodyText
                    var obj = JSON.parse(data);

                    this.q57=obj.q57;
                    this.q58=obj.q58;
                    this.q60=obj.q60;
                    this.q61=obj.q61;
                    this.q62=obj.q62;
                    this.q63=obj.q63;
                    this.q66=obj.q66;
                    this.q67=obj.q67;
                    this.q68=obj.q68;


                    myChart37.hideLoading();


                    /***********************************/
                    var arrayq62 =[
                        {value:"100"-this.q62.a ,     label: labelOption1, name:'Non'},
                        {value:this.q62.a,     label: labelOption1, name:'Oui'},
                    ]
                    var count =this.q62.count
                    myChart37.setOption({
                        title: {
                            text: ''
                        },
                        tooltip: {
                            show: true,
                            formatter: function (params)
                            {var id = params.dataIndex;
                                return Math.round(arrayq62[id].value * 0.01 *count);}
                        },
                        color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],
                        yAxis: false,
                        legend: {
                            data:['Non','Oui'],
                            bottom: '0',
                            labels: {
                                fontSize: 18
                            }
                        },

                        series: [{
                            color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],

                            name: '',
                            type: 'pie',
                            radius: ['40%', '70%'],
                            label: {normal: {formatter:'{d}% ', position: 'inner'}},
                            data:arrayq62
                        }]
                    });

                    /*********************************/
                }, response => {
                    // error callback
                });
            },
        }
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/table7FR.vue